import { Input, Modal, Select } from "antd";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";

import { Button } from "@components/Button";
import { EditorAudio } from "@components/EditorComponents/EditorAudio";
import { EditorImage } from "@components/EditorComponents/EditorImage";
import { EditorRunningText } from "@components/EditorComponents/EditorRunningText";
import { EditorStreaming } from "@components/EditorComponents/EditorStreaming";
import { EditorVideo } from "@components/EditorComponents/EditorVideo";
import { EditorWebsite } from "@components/EditorComponents/EditorWebsite";
import { EditorYoutubeLive } from "@components/EditorComponents/EditorYoutubeLive";
import { ImportAudio } from "@components/ImportImportantComponents/ImportAudio";
import { ImportImage } from "@components/ImportImportantComponents/ImportImage";
import { ImportVideo } from "@components/ImportImportantComponents/ImportVideo";
import { Text } from "@components/Text";
import { FormMultipleUpload } from "@pages/MediaListPage/FormMultipleUpload";
import { FormUpload } from "@pages/MediaListPage/FormUpload";
import {
  COLOR_GREEN,
  COLOR_GREY,
  COLOR_GREY_1,
  COLOR_WHITE,
} from "@static/COLORS";
import { CONTENTS_ATTRIBUTE_ANOTHER } from "@static/CONTENTS_ATTRIBUTE_ANOTHER";
import { DEFAULT_DURATION } from "@static/DEFAULT_DURATION";
import { MODAL_SIZE } from "@static/SIZE";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";
import { fetchAPI } from "@utils/https/fetchAPI";

import { DraggableShowMediaBlock } from "./DraggableShowMediaBlock";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  gap: 16px;
  overflow: hidden;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

const ContainerContents = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  flex-grow: 1;
  gap: 16px;
  height: calc(100% - 56px);
`;

const SectionShowMedia = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  border-radius: 6px;
  /* padding: 8px; */
  gap: 8px;
  box-sizing: border-box;
  /* border: 1px solid ${COLOR_GREY}; */
`;

const SectionAddMedia = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 6px;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid ${COLOR_GREY};
`;

const ContainerFilter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const SectionFilterSelect = styled.div`
  width: 100%;
`;

const SectionFilterInput = styled.div`
  width: 100%;
  /* border: 1px solid ${COLOR_GREY_1}; */
`;

const SectionAddMediaList = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MediaItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 8px;
  border: 1px solid ${COLOR_GREY_1};
  box-sizing: border-box;
`;

const SectionUploadMedia = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const FILTER_LIST = [
  { label: "Video", value: "video", isUseDatabase: true },
  { label: "Image", value: "image", isUseDatabase: true },
  { label: "Audio", value: "audio", isUseDatabase: true },
  { label: "Website", value: "website", isUseDatabase: false },
  { label: "Streaming", value: "video-streaming", isUseDatabase: false },
  { label: "Youtube Live", value: "youtube-live", isUseDatabase: false },
  { label: "Running Text", value: "running-text", isUseDatabase: false },
];

const MAP_IS_USE_DATABASE = {
  image: true,
  video: true,
  audio: true,
  website: false,
  "video-streaming": false,
  "youtube-live": false,
  "running-text": false,
};

export const ManageBlock = ({
  setIsModalVisible,
  importantCampaignBlocks,
  setImportantCampaignBlocks,
  importantData,
  selectedBlock,
  importantCampaignBlockMedias,
}) => {
  const location = useLocation();
  const authUserProfile = getAuthUserProfile();
  const customerId = _.get(location, ["state", "customerId"]);
  const locationId = _.get(location, ["state", "locationId"]);
  const [isCloseModal, setIsCloseModal] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);

  const [isOpenModal, setIsOpenModal] = useState({
    isOpen: false,
    modalType: null,
  });

  const [blockMediaList, setBlockMediaList] = useState(
    importantCampaignBlockMedias
  );

  const [filterText, setFilterText] = useState("");

  const [mediaList, setMediaList] = useState([]);

  const [selectedMediaType, setSelectedMediaType] = useState(
    _.chain(FILTER_LIST).first().get(["value"]).value()
  );
  // all image form database where location_id

  // แก้ตรงนี้

  // advertising-campaigns-get-media-list
  // const mediaList = useSelector(({ mediaList }) => {
  //   return _.get(mediaList, ["data"]);
  // });

  const initData = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/advertising-campaigns-get-media-list",
      isAuth: true,
      data: { location_id: locationId, customer_id: customerId },
    });
    if (_.get(resp, ["status"])) {
      const medias = _.chain(resp)
        .get(["result", "medias"])
        .groupBy((media) => {
          return _.chain(media).get(["type"]).split("/").first().value();
        })
        .value();
      console.log("medias :>> ", medias);
      setMediaList(medias);
    }
  };

  useEffect(() => {
    initData();
  }, []);
  // แก้ตรงนี้

  const onHandleImportBlockMedias = ({ item }) => {
    setBlockMediaList((prev) => {
      return [item, ...prev];
    });
  };

  const onHandleConfirm = () => {
    const blockItem = {
      ...selectedBlock,
      importantCampaignBlockMedias: blockMediaList,
    };
    const updateAdsBlock = _.map(importantCampaignBlocks, (item) => {
      return _.get(item, ["block_key"]) === _.get(blockItem, ["block_key"])
        ? blockItem
        : item;
    });

    console.log("updateAdsBlock :>> ", updateAdsBlock);
    setImportantCampaignBlocks(updateAdsBlock);
    setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
  };

  const onHandleFilterChange = (e) => {
    const value = _.get(e, ["target", "value"]);
    setFilterText(value);
  };

  const filteredDataSource = _.chain(mediaList)
    .get([selectedMediaType])
    .filter((item) => {
      const itemName = _.chain(item).get(["display_name"]).toLower().value();
      const lowerFilterText = _.toLower(filterText);
      return _.includes(itemName, lowerFilterText);
    })
    .value();
  console.log("filteredDataSource :>> ", filteredDataSource);
  const onHandleImportContentAnother = ({ type }) => {
    const contentsAttribute = _.get(CONTENTS_ATTRIBUTE_ANOTHER, [type]);
    const importantCampaignBlockMedias = {
      type: _.get(contentsAttribute, ["type"]),
      is_use_media_in_project: false,
      media_id: null,
      duration: DEFAULT_DURATION,
      repeat: 1,
      start_date: _.get(importantData, ["important_start_date"]),
      end_date: _.get(importantData, ["important_end_date"]),
      attribute: _.get(contentsAttribute, ["attribute"]),
    };
    onHandleImportBlockMedias({
      item: _.cloneDeep(importantCampaignBlockMedias),
    });
  };

  const mediaListImageKey = _.chain(mediaList)
    .get(["image"])
    .keyBy("id")
    .value();

  const mediaListVideoKey = _.chain(mediaList)
    .get(["video"])
    .keyBy("id")
    .value();

  const mediaListAudioKey = _.chain(mediaList)
    .get(["audio"])
    .keyBy("id")
    .value();

  const sectionRef = useRef(null);

  const moveBlock = (fromIndex, toIndex) => {
    if (!sectionRef.current) return;

    // 1️⃣ บันทึกตำแหน่ง Scroll ก่อนการเปลี่ยนแปลง
    const previousScrollTop = sectionRef.current.scrollTop;

    setBlockMediaList((prevBlocks) => {
      const updatedList = [...prevBlocks];
      const [movedItem] = updatedList.splice(fromIndex, 1);
      updatedList.splice(toIndex, 0, movedItem);
      return updatedList;
    });

    setTimeout(() => {
      if (sectionRef.current) {
        sectionRef.current.scrollTop = previousScrollTop;
        const targetElement = sectionRef.current.childNodes[toIndex];
        if (targetElement) {
          const scrollOffset =
            targetElement.offsetTop - sectionRef.current.offsetTop;
          sectionRef.current.scrollTo({
            top: scrollOffset,
            behavior: "smooth",
          });
        }
      }
    }, 50);
  };

  return (
    <Container>
      {/* <Line /> */}
      <InnerContainer>
        <ContainerContents>
          {/* // แก้ตรงนี้ */}
          <DndProvider backend={HTML5Backend}>
            <SectionShowMedia ref={sectionRef}>
              {_.map(blockMediaList, (item, index) => {
                const key = uuidv4();
                const type = _.get(item, ["type"]);
                const mediaId = _.get(item, ["media_id"]);

                const thumbnailPathVideo = _.chain(mediaList)
                  .get(["video"])
                  .find((findItem) => {
                    return findItem?.id === mediaId;
                  })
                  .get(["thumbnail_path"], null)
                  .value();

                return (
                  <DraggableShowMediaBlock
                    key={key}
                    campaignData={importantData}
                    type={type}
                    item={item}
                    index={index}
                    moveBlock={moveBlock}
                    mediaListImageKey={mediaListImageKey}
                    blockMediaList={blockMediaList}
                    setBlockMediaList={setBlockMediaList}
                    setActiveIndex={setActiveIndex}
                    isActive={activeIndex === index}
                    thumbnailPath={thumbnailPathVideo}
                    mediaListAudioKey={mediaListAudioKey}
                    mediaListVideoKey={mediaListVideoKey}
                  />
                );
              })}
            </SectionShowMedia>
          </DndProvider>
          {/* // แก้ตรงนี้ */}
          <SectionAddMedia>
            <SectionUploadMedia>
              <Button
                onClick={() =>
                  setIsOpenModal({ isOpen: true, modalType: "multiple upload" })
                }
                color={COLOR_GREEN}
                fontColor={COLOR_WHITE}
                padding="4px 15px"
                width="100%"
              >
                Add Multiple Media
              </Button>
              <Button
                onClick={() =>
                  setIsOpenModal({ isOpen: true, modalType: "upload" })
                }
                color={COLOR_GREEN}
                fontColor={COLOR_WHITE}
                padding="4px 15px"
                width="170px"
              >
                Add Media
              </Button>
            </SectionUploadMedia>
            <ContainerFilter>
              <SectionFilterSelect>
                <Select
                  placeholder="Select a customer"
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  options={FILTER_LIST}
                  defaultValue={selectedMediaType}
                  onChange={(value) => {
                    setSelectedMediaType(value);
                    setFilterText("");
                  }}
                  onClear={() => {
                    setSelectedMediaType(null);
                  }}
                />
              </SectionFilterSelect>
              {_.get(MAP_IS_USE_DATABASE, [selectedMediaType]) && (
                <SectionFilterInput>
                  <Input
                    placeholder="Filter by name"
                    value={filterText}
                    onChange={(e) => onHandleFilterChange(e)}
                    style={{ width: "100%" }}
                  />
                </SectionFilterInput>
              )}
            </ContainerFilter>
            <SectionAddMediaList>
              {_.get(MAP_IS_USE_DATABASE, [selectedMediaType]) &&
                _.chain(filteredDataSource)
                  // .get([selectedMediaType])
                  .map((item, index) => {
                    console.log("item :>> ", item);
                    return (
                      <MediaItem key={index}>
                        {(() => {
                          switch (selectedMediaType) {
                            case "image":
                              return (
                                <ImportImage
                                  key={index}
                                  importantData={importantData}
                                  item={item}
                                  onHandleImportBlockMedias={
                                    onHandleImportBlockMedias
                                  }
                                />
                              );
                            case "video":
                              return (
                                <ImportVideo
                                  key={index}
                                  item={item}
                                  importantData={importantData}
                                  onHandleImportBlockMedias={
                                    onHandleImportBlockMedias
                                  }
                                />
                              );

                            case "audio":
                              return (
                                <ImportAudio
                                  key={index}
                                  importantData={importantData}
                                  item={item}
                                  onHandleImportBlockMedias={
                                    onHandleImportBlockMedias
                                  }
                                />
                              );

                            default:
                              break;
                          }
                        })()}
                      </MediaItem>
                    );
                  })
                  .value()}

              {!_.get(MAP_IS_USE_DATABASE, [selectedMediaType]) && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type="button"
                    color={COLOR_GREEN}
                    padding="5px 15px"
                    onClick={() =>
                      onHandleImportContentAnother({
                        type: selectedMediaType,
                      })
                    }
                  >
                    <Text fontWeight="600" color={COLOR_WHITE}>
                      ADD
                    </Text>
                  </Button>
                </div>
              )}
            </SectionAddMediaList>
          </SectionAddMedia>
        </ContainerContents>
        <ButtonContainer>
          <Button
            onClick={() => onHandleConfirm()}
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Confirm
          </Button>
        </ButtonContainer>
      </InnerContainer>
      <Modal
        width={MODAL_SIZE}
        destroyOnClose={true}
        title={`Upload Media`}
        open={_.get(isOpenModal, ["isOpen"])}
        footer={null}
        // onCancel={() => setIsOpenModal((prev) => ({ ...prev, isOpen: false }))}
        onCancel={() => {
          if (isCloseModal) {
            setIsOpenModal((prev) => ({ ...prev, isOpen: false }));
          }
        }}
      >
        {_.get(isOpenModal, ["modalType"]) === "upload" && (
          <FormUpload
            setIsCloseModal={setIsCloseModal}
            useInManageBlock={true}
            mediaList={mediaList}
            userProfile={authUserProfile}
            location_id={locationId}
            customer_id={customerId}
            setMediaList={setMediaList}
            setIsModalVisible={setIsOpenModal}
            dataList={[]}
          />
        )}

        {_.get(isOpenModal, ["modalType"]) === "multiple upload" && (
          <FormMultipleUpload
            setMediaList={setMediaList}
            setIsCloseModal={setIsCloseModal}
            useInManageBlock={true}
            mediaList={mediaList}
            customer_id={customerId}
            location_id={locationId}
            setIsModalVisible={setIsOpenModal}
            dataList={[]}
          />
        )}
      </Modal>
    </Container>
  );
};
